<template>
  <ValidationProvider ref="provider" class="fct-input-group" :id="id + '-input'" :name="name || label" :rules="rules">
    <template v-slot="{ errors }">
      <div class="fct-input-control" :class="{'fct-error': errors[0]}">
        <label v-if="label" :for="id">{{label || capitalize}}</label>
        <input type="text" v-model="value" class="is-hidden">
        <component :is="component || 'fct-input'" v-bind="bindings || {}" :placeholder="placeholder" :prefix="prefix" :value="value" @setCustomError="err => $refs.provider.setErrors([err])" :type="type"
                   :id=id :disabled="disabled" @input="onInput($event)" @blur="onBlur($event)"></component>
        <span class="message" v-if="errors[0]"><i class="fct-admin-icon-warning"></i> {{ errors[0] }}</span>
      </div>
    </template>
  </ValidationProvider>
</template>

<script>
  import ValidationControl from "../views/projects/mixins/ValidationControl";
  export default {
    props: ['bindings', 'id', 'label', 'name', 'disabled', 'rules', 'component', 'value', 'type', 'placeholder', 'prefix'],
    mixins: [ValidationControl],
    data() {
      return {
        customError: null,
        isMounted: false
      }
    },
  }
</script>

<style scoped>

</style>
